module.exports = __webpack_public_path__ + "static/media/3.7 KC Tribunj 7-14.08.2025.bc93e197.jpg";